import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KhachHangModelLite } from '../../../dung-chung/__model/common_config.model';
import { KdYeuCauBaoGiaList } from '../kd-yeu-cau-bao-gia-model/kd-yeu-cau-bao-gia.model';
const API_ROOT_URL = environment.ApiRoot + '/kinhdoanh';

@Injectable()
export class KdYeuCauBaoGiaService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/YeuCauBaoGia_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	list(): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+'/YCBG_GetList', { headers: httpHeaders });
	}
	insert(item: KdYeuCauBaoGiaList): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/YeuCauBaoGia_Insert', item, { headers: httpHeaders });
	}

	edit(item: KdYeuCauBaoGiaList): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KdYeuCauBaoGiaList>(API_ROOT_URL+'/YeuCauBaoGia_Update', item, { headers: httpHeaders });
	}

	detail(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let httpParams = new HttpParams().set('Id',item.toString());
		return this.http.get<KdYeuCauBaoGiaList>(API_ROOT_URL+`/YeuCauBaoGia_Detail`, {
			headers: httpHeaders ,
			params: httpParams
		});
	}

	delete(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let httpParams = new HttpParams().set('Id',item.toString());
		return this.http.get<KdYeuCauBaoGiaList>(API_ROOT_URL+`/YeuCauBaoGia_Delete`, {
			headers: httpHeaders ,
			params: httpParams
		});
	}

	setKH(data: KhachHangModelLite): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + '/InsertCustomer' ;
		return this.http.post<any>(url , data ,{ headers: httpHeaders });
	}
}
